export const CLIENT_COMMAND_OPERATION_PERMISSIONS = Object.freeze({
  generateClientEntraSetupScript: 'ClientCommandGenerateClientEntraSetupScript',

  saveClientInformation: 'ClientCommandSaveClientInformation',
  setClientApplicationOptions: 'ClientCommandSetClientApplicationOptions',

  saveClientDomain: 'ClientCommandSaveClientDomain',
  removeClientDomain: 'ClientCommandRemoveClientDomain',
  generateClientDomains: 'ClientCommandGenerateClientDomains',
  deployClientDomains: 'ClientCommandDeployClientDomains',
  reconcileClientDomainProvisioning: 'ClientCommandReconcileClientDomainProvisioning',

  setUpClientDatabasePartitionIdentity: 'ClientCommandSetUpClientDatabasePartitionIdentity',
  saveClientDatabasePartitionRequest: 'ClientCommandSaveClientDatabasePartitionRequest',
  updateClientDatabasePartitionConnection: 'ClientCommandUpdateClientDatabasePartitionConnection',
  prepareClientDatabasePartition: 'ClientCommandPrepareClientDatabasePartition',
  validateClientDatabasePartition: 'ClientCommandValidateClientDatabasePartition',
  loadClientDatabasePartitionDeploymentInventory: 'ClientCommandLoadClientDatabasePartitionDeploymentInventory',
  deployClientDatabasePartition: 'ClientCommandDeployClientDatabasePartition',
  activateClientDatabasePartition: 'ClientCommandActivateClientDatabasePartition',

  saveClientEntraReadConnection: 'ClientCommandSaveClientEntraReadConnection',
  saveClientAzureMapsConnection: 'ClientCommandSaveClientAzureMapsConnection',
  removeClientAzureMapsOverride: 'ClientCommandRemoveClientAzureMapsOverride',
  validateClientEntraReadConnection: 'ClientCommandValidateClientEntraReadConnection',
  testClientEntraLogin: 'ClientCommandTestClientEntraLogin',
  saveClientEntraMapping: 'ClientCommandSaveClientEntraMapping',
  deleteClientEntraMapping: 'ClientCommandDeleteClientEntraMapping',
  loadClientGuestAccess: 'ClientCommandLoadClientGuestAccess',
  saveClientGuestAccessMode: 'ClientCommandSaveClientGuestAccessMode',
  inviteClientGuest: 'ClientCommandInviteClientGuest',
  revokeClientGuest: 'ClientCommandRevokeClientGuest',
  reconcileClientGuestAccess: 'ClientCommandReconcileClientGuestAccess',

  revokeClientActiveSession: 'ClientCommandRevokeClientActiveSession',
  activateMarketplacePayment: 'ClientCommandActivateMarketplacePayment',
  deleteMarketplacePayment: 'ClientCommandDeleteMarketplacePayment',

  createClientRoleFromPermissionSet: 'ClientCommandCreateClientRoleFromPermissionSet',
  cloneClientRole: 'ClientCommandCloneClientRole',
  saveClientRoleDetails: 'ClientCommandSaveClientRoleDetails',
  saveClientRolePermission: 'ClientCommandSaveClientRolePermission',
  assignClientUserRoles: 'ClientCommandAssignClientUserRoles',
  setClientRoleLifecycle: 'ClientCommandSetClientRoleLifecycle',

  searchClientEntraUsers: 'ClientCommandSearchClientEntraUsers',
  saveClientUserProfile: 'ClientCommandSaveClientUserProfile',
  setClientUserAccess: 'ClientCommandSetClientUserAccess',
  repairClientUserEntraMapping: 'ClientCommandRepairClientUserEntraMapping',

  saveClientThemePairDraft: 'ClientCommandSaveClientThemePairDraft',
  previewThemeDraftPair: 'ClientCommandPreviewThemeDraftPair',
  activateThemePair: 'ClientCommandActivateThemePair',
  deleteClientThemePair: 'ClientCommandDeleteClientThemePair',
  aiQuestionThemeManage: 'ClientCommandAIQuestionThemeManage',

  setUpClientFileStorage: 'ClientCommandSetUpClientFileStorage',
  validateClientFileStorage: 'ClientCommandValidateClientFileStorage',
  revertClientFileStorageToPlatform: 'ClientCommandRevertClientFileStorageToPlatform',
  resolveClientFileLocation: 'ClientCommandResolveClientFileLocation',
  saveClientFile: 'ClientCommandSaveClientFile',
  removeClientFile: 'ClientCommandRemoveClientFile',

  loadClientCommunicationTool: 'ClientCommandLoadClientCommunicationTool',
  selectClientCommunicationProviders: 'ClientCommandSelectClientCommunicationProviders',
  saveClientCommunicationConfiguration: 'ClientCommandSaveClientCommunicationConfiguration',
  validateClientCommunicationProvider: 'ClientCommandValidateClientCommunicationProvider',
  testClientCommunicationProvider: 'ClientCommandTestClientCommunicationProvider',
  saveClientCommunicationToolItem: 'ClientCommandSaveClientCommunicationToolItem',
  removeClientCommunicationToolItem: 'ClientCommandRemoveClientCommunicationToolItem',
  searchClientNotificationRecipients: 'ClientCommandSearchClientNotificationRecipients',
  saveClientInternalNotificationDraft: 'ClientCommandSaveClientInternalNotificationDraft',
  dispatchClientInternalNotification: 'ClientCommandDispatchClientInternalNotification',
  aiQuestionClientCommunicationManage: 'ClientCommandAIQuestionClientCommunicationManage',

  loadClientActivityDetail: 'ClientCommandLoadClientActivityDetail',
  resolveClientActivitySourceRecordRoute: 'ClientCommandResolveClientActivitySourceRecordRoute',
  exportClientActivitySearch: 'ClientCommandExportClientActivitySearch',
  aiQuestionClientActivity: 'ClientCommandAIQuestionClientActivity',
});

export const CLIENT_COMMAND_PRIMARY_ITEM_PERMISSIONS = Object.freeze({
  theme: 'Theme',
});
